function getObservationTimestampFromSk(sk) {
  if (typeof sk !== 'string') {
    return '';
  }

  const match = sk.match(/^OBS#([^#]+)/);
  return match?.[1] || '';
}

export function parseWeatherTimestampMs(value) {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isFinite(timestamp) ? timestamp : 0;
  }

  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      return 0;
    }

    return value >= 1e12 ? value : value * 1000;
  }

  const normalized = String(value).trim();

  if (!normalized) {
    return 0;
  }

  if (/^\d{10}(\.\d+)?$/.test(normalized)) {
    return Number(normalized) * 1000;
  }

  if (/^\d{13}$/.test(normalized)) {
    return Number(normalized);
  }

  const parsed = Date.parse(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
}

function getFirstValidTimestampMs(values) {
  for (const value of values) {
    const timestampMs = parseWeatherTimestampMs(value);

    if (timestampMs > 0) {
      return timestampMs;
    }
  }

  return 0;
}

export function isObservationSourceTimeSuspect(item) {
  const value = item?.source_time_suspect;

  return value === true || value === 1 || (
    typeof value === 'string' && value.trim().toLowerCase() === 'true'
  );
}

export function getObservationArrivalTimestampMs(item) {
  return getFirstValidTimestampMs([
    item?.received_at_utc,
    item?.ingested_at_utc,
  ]);
}

export function getObservationDisplayTimestampMs(item) {
  const displayTimestampMs = getFirstValidTimestampMs([item?.display_ts_utc]);

  if (displayTimestampMs) {
    return displayTimestampMs;
  }

  if (isObservationSourceTimeSuspect(item)) {
    return getObservationArrivalTimestampMs(item);
  }

  return getFirstValidTimestampMs([
    item?.source_ts_utc,
    item?.source_ts_sort_utc,
    item?.weather?.timestamp,
    item?.raw_payload?.payload?.weather?.timestamp,
    item?.source_ts_raw,
    getObservationTimestampFromSk(item?.sk),
    getObservationTimestampFromSk(item?.latest_observation_sk),
    item?.received_at_utc,
    item?.ingested_at_utc,
    item?.updated_at_utc,
  ]);
}
